import { Patient } from "../../api/types";

type PatientInfoProps = {
    patient: Patient
    program: string
}

export const PatientInfo = ({ patient, program }: PatientInfoProps) => {
    console.log("patient pharmacy", patient.weight_loss_pharmacy)
    return (
        <div className="flex flex-col space-y-3">
            <div className="flex flex-wrap items-center gap-2">
                <h2 className="text-sm" style={{ color: '#2D2F35' }}>
                    {patient?.email}
                </h2>
                <h2 className="text-sm" style={{ color: '#2D2F35' }}>
                    {program === "urgent-care" ? "Urgent Care" : "Weight Loss"}
                </h2>
                <div className="flex flex-wrap items-center gap-2">
                    <span className="mx-1" style={{ color: "#667085" }}>•</span>
                    <span className="text-sm" style={{ color: '#2D2F35' }}>
                        {patient?.age} Years
                    </span>
                    <span className="mx-1" style={{ color: "#667085" }}>•</span>
                    <span className="text-sm" style={{ color: '#2D2F35' }}>
                        {patient?.gender}
                    </span>
                </div>
            </div>
            <div className="shimmer-header bg-[#F1F4F9] border border-[#0000001A] rounded-[16px] p-4 shimmer-card">
                <div className="space-y-0">
                    {/* First row */}
                    <div className="grid grid-cols-3 gap-3 py-3">
                        {program === "weight-loss" && (
                            <div className="flex flex-col">
                                <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                    Full name
                                </span>
                                <span className="text-xs sm:text-base font-medium" style={{ color: '#2D2F35' }}>
                                    {patient?.name}
                                </span>
                            </div>
                        )}
                        <div className="flex flex-col">
                            <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                State
                            </span>
                            <span className="text-xs sm:text-base font-medium" style={{ color: '#2D2F35' }}>
                                {patient.state || "--"}
                            </span>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                City
                            </span>
                            <span className="text-xs sm:text-base font-medium" style={{ color: '#2D2F35' }}>
                                {patient?.city || "--"}
                            </span>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                DOB
                            </span>
                            <span className="text-xs sm:text-base font-medium" style={{ color: '#2D2F35' }}>
                                {patient?.dateOfBirth || "--"}
                            </span>
                        </div>
                        {program === "weight-loss" && (
                            <>
                                <div className="flex flex-col">
                                    <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                        Initial Weight
                                    </span>
                                    <span className="text-xs sm:text-base font-medium text-nowrap" style={{ color: '#2D2F35' }}>
                                        {patient?.initialWeight || "--"}
                                    </span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                        Goal Weight
                                    </span>
                                    <span className="text-xs sm:text-base font-medium text-nowrap" style={{ color: '#2D2F35' }}>
                                        {patient?.goalWeight || "--"}
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                    
                    {/* Horizontal divider */}
                    <div className="border-t-2 border-[#E4E7EC]"></div>
                    
                    {/* Second row */}
                    <div className="grid grid-cols-3 gap-3 py-3">
                        <div className="flex flex-col">
                            <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                Address
                            </span>
                            <span className="text-xs sm:text-base font-medium text-wrap" style={{ color: '#2D2F35' }}>
                                {patient?.address || "--"}
                            </span>
                        </div>
                        <div className="flex flex-col">
                                    <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                       Phone number
                                    </span>
                                    <span className="text-xs sm:text-base font-medium text-nowrap" style={{ color: '#2D2F35' }}>
                                        {patient?.phoneNumber || "--"}
                                    </span>
                                </div>
                        {program === "weight-loss" && (
                        <div className="flex flex-col">
                                    <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                       Preferred Pharmacy
                                    </span>
                                    <span className="text-xs sm:text-base font-medium text-wrap" style={{ color: '#2D2F35' }}>
                                        {patient?.weight_loss_pharmacy?.fulfillment_type === "recommended" ? "ProxyMedicine's Recommended" : patient?.weight_loss_pharmacy?.pharmacy?.name || "--"}
                                    </span>
                                </div>
                        )}

                        {program === "urgent-care" && (
                            <>
                                <div className="flex flex-col">
                                    <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                        Zip code
                                    </span>
                                    <span className="text-xs sm:text-base font-medium text-nowrap" style={{ color: '#2D2F35' }}>
                                        {patient?.zip_code || "--"}
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                    
                    {program === "urgent-care" && (
                        <>
                            {/* Another horizontal divider */}
                            <div className="border-t-2 border-[#E4E7EC]"></div>
                            
                            {/* Third row for Preferred Pharmacy */}
                            <div className="py-3">
                                <div className="flex flex-col">
                                    <span className="text-xs sm:text-sm text-nowrap" style={{ color: '#2D2F35' }}>
                                        Preferred Pharmacy
                                    </span>
                                    <span className="text-xs sm:text-base font-medium" style={{ color: '#2D2F35' }}>
                                        {patient?.pharmacy?.StoreName || "--"} {patient?.pharmacy?.Address1 || patient?.pharmacy?.Address2 || ""}
                                    </span>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}